import { Directive, ElementRef, Renderer2, computed, effect, inject, input, signal } from '@angular/core';
import { hlm } from '@spartan-ng/helm/utils';
import type { ClassValue } from 'clsx';
import { injectExposesStateProvider } from '@spartan-ng/brain/core';

@Directive({
  selector: '[hlmPopoverContent],[brnPopoverContent][hlm]',
  standalone: true,
  host: {
    '[class]': '_computedClass()',
  },
})
export class HlmPopoverContentDirective {
  private _stateProvider = injectExposesStateProvider({ host: true });
  public state = this._stateProvider.state ?? signal('open');
  private _renderer = inject(Renderer2);
  private _element = inject(ElementRef);

  constructor() {
    effect(() => {
      this._renderer.setAttribute(this._element.nativeElement, 'data-state', this.state());
    });
  }

  public readonly userClass = input<ClassValue>('');
  protected _computedClass = computed(() =>
    hlm(
      'relative border-border w-72 rounded-md p-4 text-popover-foreground outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
      this.userClass(),
    ),
  );
}
